import React, { useContext } from "react";
import { NavLink } from "react-router-dom";

import { AuthContext } from "../../../context/auth-context";
import "./NavLinks.css";

const NavLinks = (props) => {
  const auth = useContext(AuthContext);

  const { isLoggedIn } = auth;

  return (
    <ul className="nav-links">
      <li>
        <NavLink exact to="/places">
          All Places
        </NavLink>
      </li>
      {isLoggedIn && (
        <li>
          <NavLink to={`${auth.userId}/places`}>My Places</NavLink>
        </li>
      )}
      {isLoggedIn && (
        <li>
          <NavLink to="/places/new">Add Place</NavLink>
        </li>
      )}
      <li>
        <NavLink exact to="/users">
          Users
        </NavLink>
      </li>
      {!isLoggedIn && (
        <li>
          <NavLink to="/auth">Login / SignUp</NavLink>
        </li>
      )}
      {isLoggedIn && (
        <li>
          <button onClick={auth.logout}>Logout</button>
        </li>
      )}
    </ul>
  );
};

export default NavLinks;
